import styled from "styled-components";

export const Wrapper = styled.div``;

export const Content = styled.div``;

export const File = styled.div``;

export const Categorie = styled.div``;

export const Pictures = styled.div`
  border: solid black;
  display: flex;
  width: 300px;
  flex-direction: column;
`;

export const PicturesWrapper = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 10px;
  width: 100%;
  border: solid red;
  flex-wrap: wrap;
`;
